const selectors = {
  cartHolder: '.cart-holder',
  closeButton: '[data-close]',
};

import { setFocusTrap, unsetFocusTrap, getActiveFocusTrap } from '../global/focus-trap';
import createFocusTrap from 'focus-trap';

const focusAjaxCart = () => {
  const cartHolder = document.querySelector(selectors.cartHolder);
  const magnificIsOpen = document.querySelector('.mfp-ready');
  let focusTrap = getActiveFocusTrap();

  if (!cartHolder) return;

  const cartTitle = cartHolder.querySelector('.cart__title');

  // Magnific has its own focus trap that interferes with the ajax cart
  // TODO: make these compatible
  if (!magnificIsOpen && !focusTrap) {
    const options = {
      initialFocus: cartTitle,
      onDeactivate: closeAjaxCart,
    };

    focusTrap = createFocusTrap(cartHolder, options);
    setFocusTrap(focusTrap);
    focusTrap.activate();
  }

  cartTitle.focus();
};

const deactivateCartTrap = () => {
  const currentFocusTrap = getActiveFocusTrap();

  if (currentFocusTrap) {
    currentFocusTrap.deactivate();
    unsetFocusTrap();
  }
};

const closeAjaxCart = () => {
  const cartHolder = document.querySelector(selectors.cartHolder);

  if (!cartHolder) return;

  cartHolder.classList.add('hide');
  cartHolder.classList.remove('show');
  cartHolder.innerHTML = '';
  deactivateCartTrap();
};

const cartIsOpen = () => {
  const cartHolder = document.querySelector(selectors.cartHolder);

  if (!cartHolder) return;

  return cartHolder.classList.contains('show');
};

/**
 * Adds document listeners for:
 *  (1) clicks outside of open ajax cart
 *  (2) click on close 'button'
 */
export function addCartEventHandlers() {
  document.addEventListener('mouseup', (event) => {
    const target = event.target;
    const cartHolder = target.closest(selectors.cartHolder);

    if (!cartHolder && cartIsOpen()) {
      closeAjaxCart();
    }
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    const closeButton = target.closest(selectors.closeButton);

    if (closeButton && cartIsOpen()) {
      closeAjaxCart();
    }
  });

  // Add fallback ESC to close for when focus trap isn't active (i.e. Quick Add)
  document.addEventListener('keyup', (event) => {
    if (!cartIsOpen) return;

    const focusTrapExists = getActiveFocusTrap();

    if (event.key === 'Escape' && !focusTrapExists) {
      closeAjaxCart();
    }
  });
}

/**
 * Handles accessible show/hide for cart drawer
 * Moves & traps focus; adds keypress listeners for ESC to close.
 * @param {DOM Element} html
 */
export function openAjaxCart(html) {
  const cartHolder = document.querySelector(selectors.cartHolder);

  if (!cartHolder) return;

  cartHolder.innerHTML = '';
  cartHolder.classList.add('show');
  cartHolder.classList.remove('hide');
  cartHolder.appendChild(html);
  focusAjaxCart();
}
